import { render, staticRenderFns } from "./ChannelUserCounterBadge.vue?vue&type=template&id=77fa99e8&scoped=true&"
import script from "./ChannelUserCounterBadge.vue?vue&type=script&lang=ts&"
export * from "./ChannelUserCounterBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fa99e8",
  null
  
)

export default component.exports